module.exports = __webpack_public_path__ + "img/gnu_gallery2.1d75d5f4.jpg";